import { useState } from "react";
import { uid } from "../lib/api";

const resize = (arr, n, make) => { const out = arr.slice(0, n); while (out.length < n) out.push(make()); return out; };
const newAlloc = () => ({ id: uid("alloc"), mode: "organization", nominee: {} });
const newGuest = () => ({ id: uid("guest"), name: "" });
const FALLBACK_PKG = { key: "single", price: 0, children: 1, vip_seats: 2, scarves: 1, name: "" };

export function useSponsorForm(packages) {
  const [pkgKey, setPkgKey] = useState("single");
  const [qty, setQty] = useState(1);
  const [allocations, setAllocations] = useState(() => [newAlloc()]);
  const [guests, setGuests] = useState(() => [newGuest(), newGuest()]);
  const pkg = packages.find((p) => p.key === pkgKey) || FALLBACK_PKG;

  const applySize = (p, v) => {
    setAllocations((prev) => resize(prev, p.children * v, newAlloc));
    setGuests((g) => resize(g, p.vip_seats * v, newGuest));
  };
  const setQtyChecked = (n) => { const v = Math.max(1, Math.min(10, n)); setQty(v); applySize(pkg, v); };
  const choosePkg = (p) => { setPkgKey(p.key); applySize(p, qty); };
  const setAlloc = (id, patch) => setAllocations((prev) => prev.map((a) => (a.id === id ? { ...a, ...patch } : a)));
  const setNominee = (id, patch) => setAllocations((prev) => prev.map((a) => (a.id === id ? { ...a, nominee: { ...a.nominee, ...patch } } : a)));
  const setGuestName = (id, name) => setGuests((prev) => prev.map((g) => (g.id === id ? { ...g, name } : g)));

  return {
    pkg, pkgKey, qty, allocations, guests,
    children: pkg.children * qty, seats: pkg.vip_seats * qty, total: pkg.price * qty,
    setQtyChecked, choosePkg, setAlloc, setNominee, setGuestName,
  };
}
